<template>
  <div id="app">
    <Pic src="//res.aidalan.com/hd/sg/img/top.jpg" title="三国礼包"></Pic>
    <!-- <Login return-url="http://hd.aidalan.com/loginReturn"></Login> -->
    <Winners></Winners>
    <div class="lottery">
      <Lottery></Lottery>
    </div>
    <Handle @addrModel="addrModel" @recordModel="recordModel"></Handle>
    <Countdown start-time="2018/9/28 23:59:59"></Countdown>
    <Introduce></Introduce>
    <addrForm ref="addrRef"></addrForm>
    <winRecord ref="recordRef"></winRecord>
  </div>
</template>

<script>
import Pic from './components/Pic';
import Login from './components/Login';
import Winners from './components/Winners';
import Lottery from './components/Lottery';
import Handle from './components/Handle';
import bottomPic from './assets/bottom.png';
import addrForm from './components/addrForm';
import winRecord from './components/winRecord';
import Countdown from './components/Countdown';
import Introduce from './components/Introduce';

export default {
  data() {
    return {
      bottomPic,
    };
  },
  components: {
    Pic,
    Login,
    Winners,
    Lottery,
    Handle,
    addrForm,
    winRecord,
    Countdown,
    Introduce,
  },
  created() {
    const isWx = /MicroMessenger/i.test(navigator.userAgent.toLowerCase());
    if (isWx) {
      this.$store.dispatch('getUserInfo');
    }
  },
  mounted() {
    window.addEventListener('message', (ev) => {
      if (ev.data.type === 'loginSuccess') {
        this.$store.dispatch('getUserInfo');
        this.$store.commit('setShowLogin', false);
        this.$Message.success('登录成功！');
      }
    });
  },
  methods: {
    addrModel() {
      this.$refs.addrRef.setAddrModel();
    },
    recordModel() {
      this.$refs.recordRef.setRecordModel();
    },
  },
};
</script>

<style>
html, body{
  height: 100%;
}
body{
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  background: url(//res.aidalan.com/hd/sg/img/bg.png) #462248 no-repeat center bottom;
  background-size: 100%;
}
.lottery{
  margin: 1.6vw 0;
  padding: 2vw;
}
@media (min-width: 640px) {
  .lottery{
    padding: 16px;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue